!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.storeblocks=t():e.storeblocks=t()}(self,(()=>(()=>{"use strict";var e={279:(e,t,o)=>{o.d(t,{HintBase:()=>i,Text:()=>s});const n=require("styled-components");var r=o.n(n);const i=r().div.attrs({className:"hint"})`
  & > p {
    font-size: 14px;
    line-height: 24px;
  }

  & > button {
    font-size: 14px;
    line-height: 24px;
    border: none;
    color: inherit;
    background: transparent;
    text-decoration: underline;

    padding: 0;
    cursor: pointer;
  }

  & > button:focus {
    outline: var(--outline);
    outline-offset: 4px;
  }
  & > button:focus:not(:focus-visible) {
    outline: 0;
  }
  & > button:focus-visible {
    outline: var(--outline);
    outline-offset: 4px;
  }
`,s=r().p`
  margin: 0;

  & > a {
    font-size: inherit;
  }

  ${({$lines:e,$open:t,$maxLines:o})=>0!==e&&!t&&n.css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${o};
      -webkit-box-orient: vertical;
    `}
`}},t={};function o(n){var r=t[n];if(void 0!==r)return r.exports;var i=t[n]={exports:{}};return e[n](i,i.exports,o),i.exports}o.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return o.d(t,{a:t}),t},o.d=(e,t)=>{for(var n in t)o.o(t,n)&&!o.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},o.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),o.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var n={};return(()=>{o.r(n),o.d(n,{Hint:()=>l,LINE_HEIGHT:()=>s,default:()=>a});const e=require("react");var t=o.n(e),r=o(279),i=function(e,t){var o={};for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&t.indexOf(n)<0&&(o[n]=e[n]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var r=0;for(n=Object.getOwnPropertySymbols(e);r<n.length;r++)t.indexOf(n[r])<0&&Object.prototype.propertyIsEnumerable.call(e,n[r])&&(o[n[r]]=e[n[r]])}return o};const s=24;function l(o){var{children:n,maxLines:l=2,readLessLabel:a="read less",readMoreLabel:u="read more"}=o,c=i(o,["children","maxLines","readLessLabel","readMoreLabel"]);const[f,p]=(0,e.useState)(!1),[d,b]=(0,e.useState)(0),x=(0,e.useRef)();return(0,e.useEffect)((()=>{const{offsetHeight:e}=x.current;b(e/s)}),[]),t().createElement(r.HintBase,Object.assign({ref:x},c),t().createElement(r.Text,{$maxLines:l,$lines:d,$open:f},n),d>l?t().createElement("button",{type:"button",onClick:()=>p(!f)},f?a:u):null)}const a=l})(),n})()));
//# sourceMappingURL=index.js.map